import $ from "jquery";
import css3Animate from "ztgamejs/css3animate";
class AnimateCss {
  constructor() {}
  static run(ele, addToAll, tag) {
    if (typeof addToAll == "undefined") {
      addToAll = true;
    }
    if (!tag) {
      tag = "name";
    }
    if (!AnimateCss.animateEls) {
      AnimateCss.animateEls = [];
    }
    ele = $(ele);
    var anEls;
    if (!ele.hasClass("animation")) {
      anEls = ele.find(".animation");
    } else {
      anEls = ele;
    }

    anEls.each(function() {
      var ele = $(this);
      if (ele.data(tag)) {
        var an = {
          name: ele.data(tag),
          delay: ele.data("delay") || 0,
          duration: ele.data("duration") || 300,
          easing: ele.data("easing") || "ease-in-out",
          el: ele,
        };
        if (!an.name) {
          return true;
        }
        css3Animate.keyframe.run(
          an.el,
          an.name,
          {
            speed: an.duration,
            delay: an.delay,
            easing: an.easing,
          },
          function() {
            if (!addToAll) {
              an.el.removeClass("animation");
              an.el.removeClass("animated");
              css3Animate.keyframe.stop(an.el);
            }
            css3Animate.keyframe.pause(an.el);
          }
        );
        an.el.addClass("animated");
        if (addToAll) {
          AnimateCss.animateEls.push(an);
        }
      }
    });
  }
  static out(ele, addToAll) {
    if (typeof addToAll == "undefined") {
      addToAll = true;
    }
    this.run(ele, addToAll, "out");
  }
  static stop(ele) {
    ele = $(ele);
    var anEls;
    if (!ele.hasClass("animation")) {
      anEls = ele.find(".animation");
    } else {
      anEls = ele;
    }
    anEls.each(function() {
      var curel = $(this);
      css3Animate.keyframe.stop(curel);
      curel.removeClass("animated");
      for (var i in AnimateCss.animateEls) {
        if (curel[0] == AnimateCss.animateEls[i][0]) {
          AnimateCss.animateEls.splice(i, 1);
          break;
        }
      }
    });
  }
  static stopAll() {
    for (var i in AnimateCss.animateEls) {
      css3Animate.keyframe.stop(AnimateCss.animateEls[i]["el"]);
      AnimateCss.animateEls[i]["el"].removeClass("animated");
    }
    AnimateCss.animateEls = [];
  }
}
export default AnimateCss;
